import connectToStores from "alt-utils/lib/connectToStores";
import PropTypes from "prop-types";
import React, { Component } from "react";

import ActionBar from "./ActionBar";

import ConfirmationMessageStore from "../../stores/chat/ConfirmationMessageStore";

class ActionBarContainer extends Component {
    static getStores() {
        return [ConfirmationMessageStore];
    }

    static getPropsFromStores() {
        return {
            buttons: ConfirmationMessageStore.getState().buttons,
            isLoading: ConfirmationMessageStore.getState().isLoading,
        };
    }

    render() {
        const { buttons, isLoading, scrollMessageListToBottom, setOffsetBottomOfMessageList } = this.props;

        return (
            <ActionBar
                buttons={buttons}
                isLoading={isLoading}
                scrollMessageListToBottom={scrollMessageListToBottom}
                setOffsetBottomOfMessageList={setOffsetBottomOfMessageList}
            />
        );
    }
}

ActionBarContainer.propTypes = {
    buttons: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            onClick: PropTypes.func.isRequired,
        })
    ).isRequired,
    isLoading: PropTypes.bool.isRequired,
    scrollMessageListToBottom: PropTypes.func.isRequired,
    setOffsetBottomOfMessageList: PropTypes.func.isRequired,
};

export default connectToStores(ActionBarContainer);
